export const rules = {
    text: [
        { required: true, message: 'Пожалуйста, введите text ', trigger: 'blur' },
    ],
};
